import codeAccess from './codeAccess'
import game from './game'
import modals from './modals'
import statusBar from './statusBar'
import auth from './auth'
import formValidation from './formValidation'
import error from './error'
import meta from './meta'
import onboarding from './onboarding'
import presets from './presets'
import tour from './tour'
import modal from './modal'
import mc from './mc'
import superadmin from './superadmin'

export default {
    codeAccess,
    game,
    modals,
    statusBar,
    auth,
    formValidation,
    error,
    meta,
    onboarding,
    presets,
    tour,
    modal,
    mc,
    superadmin
}



// WEBPACK FOOTER //
// src/lang/locales/en/index.js